import * as yup from "yup";

export const renameUserScheduleFormValidationSchema = yup.object().shape({
  scheduleName: yup
    .string()
    .trim()
    .required("Schedule name is required")
    .typeError("Must be a valid string"),
});

export type RenameUserScheduleFormValuesYup = yup.InferType<
  typeof renameUserScheduleFormValidationSchema
>;
export type RenameUserScheduleFormValues = {
  scheduleName: RenameUserScheduleFormValuesYup["scheduleName"];
  scheduleId: string;
};
